<template>
  <div height="100vh">
    <div v-html="parsedText"></div>
  </div>
</template>

<script>
import ModParticipant from "../modules/ModParticipant";
import config from "../assets/config";

export default {
  name: "ViewResult",
  data() {
    return {};
  },
  computed: {
    resultLink() {
      return (
        config.server.protocol +
        "://" +
        config.server.host +
        config.server.basePath +
        "/results/generate/pdf?id=" +
        ModParticipant.data.tan +
        "-" +
        this.$specs.accountId +
        "-" +
        this.$specs.projectId + "#toolbar=0"
      );
    },
    parsedText() {
      return this.$t("result.text")
        .replace(/\{\{link}}/g, this.resultLink)
        .replace(/\{\{embed}}/g, '<embed src="' + this.resultLink + '" height="100%" width="100%"/>');
    },
  },
};
</script>

<style>
embed {
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  z-index: 99999;
}
.head {
  display: block !important;
}
</style>
